<template>
  <el-dialog
    :title="$t('editMapping.title')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item :label="$t('editMapping.domain')" prop="domain">
        <el-select 
          v-model="form.domain" 
          :placeholder="$t('editMapping.selectConfigItem')"
          style="width:100%"
        >
          <el-option
            v-for="item in domains"
            :key="item.domain"
            :label="item.domainName"
            :value="item.domain"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editMapping.name')" prop="name">
        <el-input 
          v-model="form.name" 
          :placeholder="$t('editMapping.enterName')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editMapping.key')" prop="mappingKey">
        <el-input 
          v-model="form.mappingKey" 
          :placeholder="$t('editMapping.enterKey')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editMapping.value')" prop="value">
        <el-input 
          v-model="form.value" 
          :placeholder="$t('editMapping.enterValue')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editMapping.remark')">
        <el-input
          type="textarea"
          :placeholder="$t('editMapping.enterRemark')"
          v-model="form.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editMapping">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateMapping, listMappingDomains } from '@/api/dev/mappingApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditMapping',
  data() {
    return {
      dialogVisible: false,
      domains: [],
      form: {
        id: '',
        domain: 'DOMAIN.COMMON',
        name: '',
        mappingKey: '',
        value: '',
        remark: ''
      },
      rules: {
        domain: [
          { required: true, message: this.$t('editMapping.domainRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('editMapping.domainMaxLength'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('editMapping.nameRequired'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('editMapping.nameLength'), trigger: 'blur' }
        ],
        mappingKey: [
          { required: true, message: this.$t('editMapping.keyRequired'), trigger: 'blur' },
          { min: 1, max: 100, message: this.$t('editMapping.keyLength'), trigger: 'blur' }
        ],
        value: [
          { required: true, message: this.$t('editMapping.valueRequired'), trigger: 'blur' },
          { min: 1, max: 100, message: this.$t('editMapping.valueLength'), trigger: 'blur' }
        ],
        id: [
          { required: true, message: this.$t('editMapping.idRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(mapping) {
      this.form = { ...mapping }
      this.dialogVisible = true
      this.listEditMappingDomains()
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.form = {
        id: '',
        domain: 'DOMAIN.COMMON',
        name: '',
        mappingKey: '',
        value: '',
        remark: ''
      }
    },
    editMapping() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
            shopId: getShopId()
          }
          updateMapping(params).then(() => {
            this.$message.success(this.$t('editMapping.saveSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          }).catch(error => {
            this.$message.error(error.message)
          })
        }
      })
    },
    listEditMappingDomains() {
      listMappingDomains().then(response => {
        this.domains = response.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    }
  }
}
</script>